/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReportService} from '../../../../services/report.service';
import {ReportHistoryProvider} from '../../../../providers';
import {Helpers, Report} from '../../../../model';
import { HistoryEmail } from 'src/app/model/history.emails';
import { LetterType } from 'src/app/model/enums/letter.type';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EmailInfoModal } from 'src/app/components/modal';
import { Subject } from 'rxjs';
import { LogService } from 'src/app/services';

@Component({
  selector: 'page-report-emails',
  templateUrl: 'report.emails.page.html',
  styleUrls: ['report.emails.page.scss']
})
export class ReportHistoryEmailsPage implements OnInit, OnDestroy {
  currentReport: Report;
  private reportSub: any;

  emails: HistoryEmail[] = [];
  LetterType = LetterType;
  modalRef: BsModalRef;

  totalItems = 0;
  currentPage = 1;
  isLoading = false;

  constructor(
    private modalService: BsModalService,
    private reportService: ReportService,
    public reportHistoryProvider: ReportHistoryProvider,
    private logService : LogService
  ) {}

  ngOnInit(): void {
    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
      if (this.currentReport)
        this.loadEmails(this.currentReport.ID, 1);
    });
  }

  ngOnDestroy(): void {
    if (this.reportSub) this.reportSub.unsubscribe();
  }

  loadEmails(id: string, page: number): void {
    this.isLoading = true;

    this.reportHistoryProvider.getHistoryEmails(id, page)
      .subscribe(
        data => {
          this.isLoading = false;
          if (data.success) {
            this.emails = HistoryEmail.parseArray(data.result.items);
            this.totalItems = data.result.totalItems;
            this.currentPage = page;
          }
        }, err => {
          this.isLoading = false;
          this.logService.error(err);
        });
  }

  gotoEmail(email: HistoryEmail): void {

    const config = Helpers.getModalConfig();
    config.class = 'modal-lg';

    this.modalRef = this.modalService.show(EmailInfoModal, config);
    const ackSubject = new Subject<HistoryEmail>();
    this.modalRef.content.subject = ackSubject;
    this.modalRef.content.email = email;

    ackSubject.subscribe(value => {
      if(value){
      }
    });
  }

  pageChanged(event: any): void {
    if (event.page != this.currentPage)
      this.loadEmails(this.currentReport.ID, event.page);
  }
}
